import { type ReactNode } from "react";
import { Navigate } from "react-router";
import { useAuth } from "./auth";
import { AppLoader } from "@/components/app-loader";

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) return <AppLoader />;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return <>{children}</>;
}
